import { Injectable } from '@angular/core';
//import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
import { IEventReminder } from '@boxx/events-core';

@Injectable()
export class LocalNotificationsService {
  private hasPermission = false;

  constructor(
    //private localNotifications: LocalNotifications
    ) {}

  setReminder(reminder: IEventReminder): void {
    const today = new Date();
    if (reminder.date > today) {
      // this.localNotifications.schedule({
      //   id: reminder.id,
      //   title: reminder.title,
      //   text: reminder.text,
      //   trigger: { at: reminder.date },
      // });
    }
  }

  removeReminder(id: number): Promise<unknown> {
    return new Promise((resolve, reject) =>
    resolve(true)
    //   this.localNotifications
    //     .cancel(id)
    //     .then(
    //       () => {
    //         console.log('--- notification  OK');
    //         resolve(true);
    //       },
    //       error => {
    //         console.error('--- removeReminder', error);
    //         reject(error);
    //       }
    //     )
    //     .catch(err => {
    //       reject(err);
    //     })
     );
  }

  updateReminder(reminder: IEventReminder): void  {
    const today = new Date();
    if (reminder.date > today) {
      // this.localNotifications
      //   .clear(reminder.id)
      //   .then(() => this.setReminder(reminder))
      //   .catch(err => console.warn('Reminder not cleared', err));
    }
  }

  checkIdScheduled(id: number): void  {
    // this.localNotifications.isScheduled(id).then(scheduled => {
    //   console.log('isScheduled', scheduled);
    // });
  }

  init(): Promise<unknown> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      resolve(true)
      // await this.localNotifications.hasPermission().then(
      //   granted => {
      //     if (!granted) {
      //       console.warn('*** Requesting permission for Local Notifications...');

      //       this.localNotifications.requestPermission().then(r => {
      //         console.log('--- Local notifications permission: ', r);

      //         this.hasPermission = r;
      //       });
      //     } else {
      //       this.hasPermission = true;
      //     }
      //   },
      //   error => {
      //     console.error('*** localNotifications.hasPermission()', error);

      //     return reject(error);
      //   }
      // );

      // resolve(this.hasPermission);

      // if (this.hasPermission) {
      //   this.localNotifications
      //     .fireQueuedEvents()
      //     .then(
      //       resp => console.log('--- fireQueuedEvents OK', resp),
      //       error => console.error('--- fireQueuedEvents ERROR', error)
      //     )
      //     .catch(e => console.error('--- CATCH: fireQueuedEvents', e));
      // }
    });
  }

  stop(): void {
    // this.localNotifications.cancelAll().then(() => {
    //   this.localNotifications.clearAll().then();
    // });
  }
}
